import FieldPopover from "../popover/popover"
import FieldConfig from "../../proto/field-config"
import FieldIconWithColor_Popover from "./components/popover/popover"
import FieldIconWithColor_PickerValueNotEmpty from "./components/picker/value-not-empty"
import FieldIconWithColor_View from "./render/view"
import FieldIconWithColor_Picker from "./render/picker"
import {TaskIconOptions} from "../../../gd/const/item-icon/task-categories";
import {ItemIconDict} from "../../../gd/const/item-icon/icon/icons";

export default class FieldIconWithColor extends FieldPopover {
    constructor(config:FieldConfig) {
        super(config)

        this.label      = '' // no hint

        const defaultOptionsGroup = ['i5-numbers', 'i5-percent']

        _.map(TaskIconOptions, group=>_.map(group, value=>{
            if (value === 'bucket') return // there are same icon for paint_bucket and bucket with different names (ii5-paint-bucket and ii5-bucket)

            defaultOptionsGroup.push(ItemIconDict[value].className)
        }))

        this.options    = _.get(config, 'options', [defaultOptionsGroup])

        _.assign(this.components, {
            PopoverMenu         : FieldIconWithColor_Popover,

            PickerValueNotEmpty : FieldIconWithColor_PickerValueNotEmpty,
        })

        _.assign(this.renderComponents, {
            view                : FieldIconWithColor_View,

            picker              : FieldIconWithColor_Picker,
        })
    }
}
